// @flow
import firebase from 'firebase'

const config = {
    apiKey: "AIzaSyD9wvtF9E-5cDw3xa8hyhs3Zst_K6XE_m8",
    authDomain: "afp-client.firebaseapp.com",
    databaseURL: "https://afp-client.firebaseio.com",
    projectId: "afp-client",
    storageBucket: "afp-client.appspot.com",
    messagingSenderId: "83549366389"
}

export class FireBaseApp {
  config: $npm$firebase$Config
  app: firebase.app.App
  database: firebase.database.Database

  constructor() {
    this.config = config
    this.app = firebase.initializeApp(this.config)
    this.database = firebase.database()
  }

  getCustomItemValue(item: string): Promise<firebase.database.DataSnapshot> {
    return this.database.ref(item).once('value')
  }

  getDailyItemsValue(): Promise<firebase.database.DataSnapshot> {
    return this.getCustomItemValue('/dailyItems/')
  }

  getPhotographersValue(): Promise<firebase.database.DataSnapshot> {
    return this.getCustomItemValue('/photographers/')
  }
}


// WEBPACK FOOTER //
// ./src/utils/firebaseUtils.js